import { routes } from "@/consts";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { Link } from "react-router-dom";
import ChangePasswordForm from "./components/change-password-form";

export default function ChangePasswordPage() {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  return (
    <main className="flex min-h-screen flex-col items-center justify-center p-4 sm:p-6">
      <section className="w-full max-w-md bg-primary-white p-5 shadow-xl rounded-md sm:max-w-lg">
        <div className="flex flex-col mb-4">
          <h1 className="text-2xl font-semibold sm:text-3xl">
            {t("authentication.changePassword.title")}
          </h1>
          <p className="text-sm text-textcolor-mediumGray sm:text-base">
            {t("authentication.changePassword.body")}
          </p>
        </div>
        <ChangePasswordForm />
        <p className="text-sm text-textcolor-mediumGray mt-4">
          {t("actions.backTo")}{" "}
          <span className="underline text-secondary-brightYellow cursor-pointer">
            <Link to={routes.profile}>{t("profile.title")}</Link>
          </span>
        </p>
      </section>
    </main>
  );
}
